import { render, staticRenderFns } from "./bgSetting.vue?vue&type=template&id=00e7d5c8&scoped=true&"
import script from "./bgSetting.vue?vue&type=script&lang=js&"
export * from "./bgSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e7d5c8",
  null
  
)

export default component.exports